"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = detectSlowConnectionSaga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _connect = require("../actions/connect");

var _reconnect = require("../actions/reconnect");

var _sleep = _interopRequireDefault(require("../utils/sleep"));

var _marked = /*#__PURE__*/_regenerator["default"].mark(detectSlowConnectionSaga);

var SLOW_CONNECTION_AFTER = 15000;

function detectSlowConnectionSaga() {
  var connectivityRace;
  return _regenerator["default"].wrap(function detectSlowConnectionSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.take)([_connect.CONNECT_PENDING, _reconnect.RECONNECT_PENDING]);

        case 2:
          _context.next = 4;
          return (0, _effects.race)({
            fulfilled: (0, _effects.take)([_connect.CONNECT_FULFILLED, _reconnect.RECONNECT_FULFILLED]),
            rejected: (0, _effects.take)([_connect.CONNECT_REJECTED, _reconnect.RECONNECT_REJECTED]),
            slow: (0, _effects.call)(function () {
              return (0, _sleep["default"])(SLOW_CONNECTION_AFTER);
            })
          });

        case 4:
          connectivityRace = _context.sent;

          if (!('slow' in connectivityRace)) {
            _context.next = 8;
            break;
          }

          _context.next = 8;
          return (0, _effects.put)({
            type: _connect.CONNECT_STILL_PENDING
          });

        case 8:
          _context.next = 0;
          break;

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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